import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";
import { useParams } from "react-router";

const AddNewSDAData = ({ getStudyCDISCSDA }) => {
  const [sourceDatasetName, setSourceDatasetName] = useState("");
  const [sourceDatasetLabel, setSourceDatasetLabel] = useState("");
  const [sourceVariableName, setSourceVariableName] = useState("");
  const [sourceVariableLabel, setSourceVariableLabel] = useState("");
  const [sourceVariableType, setSourceVariableType] = useState("");
  const { studyId } = useParams()

  const [targetDomainName, setTargetDomainName] = useState("");
  const [targetDomainLabel, setTargetDomainLabel] = useState("");

  const [targetVariableName, setTargetVariableName] = useState("");
  const [targetVariableLabel, setTargetVariableLabel] = useState("");

  const [functionName, setFunctionName] = useState("");
  const [evaluatorName, setEvaluatorName] = useState("");
  const [codeList, setCodeList] = useState("");

  const [buttonLoader, setButtonLoader] = useState(false);

  const [libraryList, setFormLibraryList] = useState([]);
  const [formLibraryTemplate, setFormLibraryTemplate] = useState([]);
  const [domainList, setFormDomainList] = useState([]);
  const [variableList, setFormVariableList] = useState([]);
  const [functionDataList, setFormFunctionDataList] = useState([]);
  const [evaluatorsDataList, setFormEvaluatorsDataList] = useState([]);
  const [termsMetadata, setTermsMetadata] = useState([]);

  const getFormLibraryData = async () => {
    const data = await cdiscManagementService.getFormLibraryData("active");
    setFormLibraryList(data?.data || []);
  };

  const getFormTemplatesData = async (formId) => {
    const data = await cdiscManagementService.getFormTemplatesData("active", formId);
    setFormLibraryTemplate(data?.data || []);
  };

  const getDomainData = async () => {
    const data = await cdiscManagementService.getDomainData("active", "all");
    setFormDomainList(data?.data || []);
  };

  const getVariableData = async (domainId) => {
    if (!domainId) return;
    const data = await cdiscManagementService.getVariableData("active", domainId);
    setFormVariableList(data?.data || []);
  };

  const getFunctionsData = async () => {
    const data = await cdiscManagementService.getFunctionsData("active");
    setFormFunctionDataList(data?.data || []);
  };

  const getEvaluatorsData = async () => {
    const data = await cdiscManagementService.getEvaluatorsData("active");
    setFormEvaluatorsDataList(data?.data || []);
  };

  const getCDISCCLookUp = async () => {
    const data = await cdiscManagementService.getCDISCCLookUp("active");
    setTermsMetadata(data?.data || []);
  };

  const handleSourceDatasetChange = (e) => {
    const selectedId = e.target.value;
    const selectedItem = libraryList.find(item => item.formId === selectedId);
    setSourceDatasetName(selectedItem?.name || "");
    setSourceDatasetLabel(selectedItem?.label || "");
    getFormTemplatesData(selectedId)
  };

  const handleSourceVariableChange = (e) => {
    const selectedId = e.target.value;
    const selectedItem = formLibraryTemplate.find(item => item.templateId === selectedId);
    setSourceVariableName(selectedItem?.name || "");
    setSourceVariableLabel(selectedItem?.label || "");
    setSourceVariableType(selectedItem?.type || "");
  };

  const handleTargetDomainChange = (e) => {
    const selectedId = e.target.value;
    const selectedItem = domainList.find(item => item.domainId === selectedId);
    setTargetDomainName(selectedItem?.code);
    setTargetDomainLabel(selectedItem?.domain);
    setTargetVariableName("");
    getVariableData(selectedId);
  };

  const handleTargetVariableChange = (e) => {
    const id = e.target.value;
    const selectedItem = variableList.find(item => item.variableId === id);
    setTargetVariableName(selectedItem?.name || "");
    setTargetVariableLabel(selectedItem?.label || "");
  };

  useEffect(() => {
    getFormLibraryData();
    getDomainData();
    getEvaluatorsData();
    getFunctionsData();
    getCDISCCLookUp();
  }, []);

  const addNewStudyCDISCSDA = async () => {
    setButtonLoader(true);
    const userData = {
      studyId,
      sourceDatasetName,
      sourceDatasetLabel,
      sourceVariableName,
      sourceVariableLabel,
      sourceVariableType,
      targetDomainName,
      targetDomainLabel,
      targetVariableName,
      targetVariableLabel,
      functionName,
      evaluatorName,
      codeList,
    };
    const data = await cdiscManagementService.addNewStudyCDISCSDA(userData);
    if (data?.statusCode === 200){
      getStudyCDISCSDA();
      setButtonLoader(false);
      clearForm();
    } 
    setButtonLoader(false);
  };

  const clearForm = () => {
    setTargetVariableName("");
    setSourceVariableType("");
    setFunctionName("");
    setEvaluatorName("");
    setCodeList("");
    setFormLibraryList([]);
    setFormDomainList([]);
    setFormVariableList([]);
    setFormFunctionDataList([]);
    setFormEvaluatorsDataList([]);
    setTermsMetadata([]);
  }

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold">
          Source Dataset <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select onChange={handleSourceDatasetChange}>
          <option value="">Select Source Data Label</option>
          {libraryList?.map((item) => (
            <option key={item?._id} value={item?.formId}>
              {item?.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
       <Form.Group className="mb-1">
        <Form.Label className="fw-bold">
          Source Variable Name <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select onChange={handleSourceVariableChange}>
          <option value="">Select Source Variable</option>
          {formLibraryTemplate?.map((item) => (
            <option key={item._id} value={item.templateId}>
              {item.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold">
          Target Domain <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select onChange={handleTargetDomainChange}>
          <option value="">Select Target Domain</option>
          {domainList?.map((item) => (
            <option key={item?.domainId} value={item?.domainId}>
              {item?.domain} ({item?.code})
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold">
          Target Variable <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select onChange={handleTargetVariableChange}>
          <option value="">Select Variable</option>
          {variableList?.map((item) => (
            <option key={item._id} value={item.variableId}>
              {item.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold">Function</Form.Label>
        <Form.Select onChange={(e) => setFunctionName(e.target.value)}>
          <option value="">Select Function</option>
          {functionDataList?.map((item) => (
            <option key={item._id} value={item.name}>
              {item.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold">Evaluator</Form.Label>
        <Form.Select onChange={(e) => setEvaluatorName(e.target.value)}>
          <option value="">Select Evaluator</option>
          {evaluatorsDataList?.map((item) => (
            <option key={item._id} value={item.name}>
              {item.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {/* CodeList */}
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold">Codelist</Form.Label>
        <Form.Select onChange={(e) => setCodeList(e.target.value)}>
          <option value="">Select Codelist</option>
          {termsMetadata?.map((item) => (
            <option key={item._id} value={item.mappingGroup}>
              {item.mappingGroup}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {/* Submit */}
      <Form.Group className="text-end pt-2">
        <button
          disabled={buttonLoader}
          onClick={addNewStudyCDISCSDA}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add SDA Data"
          )}
        </button>
      </Form.Group>
    </div>
  );
};

export default AddNewSDAData;
